import { resolveIdParam } from '@/components/Functional/utils/resolveIdParam'
import { RewardsDetailPage } from '@/features/pages/rewards'
import type { NextPage } from 'next'
import { useRouter } from 'next/router'

const RewardDetailNextPage: NextPage = () => {
  const router = useRouter()

  if (!router.isReady) {
    return null
  }

  const id = resolveIdParam(router.query.id, router.query.query)

  if (id === null) {
    return null
  }

  return (
    <div>
      <RewardsDetailPage id={id} />
    </div>
  )
}

export default RewardDetailNextPage

export { getStaticPaths, getStaticProps } from '@/components/Functional/utils/getStaticFunctions'
